import React from 'react';
import { InstagramOutlined, TwitterOutlined, YoutubeOutlined, MailOutlined, LinkOutlined } from '@ant-design/icons';

// TikTok/WhatsApp/Spotify have no brand glyph in @ant-design/icons, so these
// are small hand-drawn approximations (not the exact trademarked logos) —
// swap in official brand SVGs later if pixel-accurate marks are needed.
const TikTokGlyph = () => (
  <svg className="social-icon" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16.5 3c.4 2 1.8 3.4 3.8 3.7v2.6c-1.4 0-2.7-.4-3.8-1.2v6.4c0 3.1-2.5 5.5-5.6 5.5S5.3 17.6 5.3 14.5c0-3 2.4-5.4 5.4-5.5v2.7c-1.5.1-2.7 1.4-2.7 2.9 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9V3h2.7z" />
  </svg>
);

const WhatsappGlyph = () => (
  <svg className="social-icon" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3a9 9 0 0 0-7.7 13.6L3 21l4.5-1.3A9 9 0 1 0 12 3zm0 2a7 7 0 1 1-3.7 12.9l-.3-.2-2.6.8.8-2.5-.2-.3A7 7 0 0 1 12 5zm-3.2 3.6c-.2 0-.5 0-.6.3-.2.2-.7.7-.7 1.7s.7 2 .8 2.1c.1.1 1.4 2.3 3.6 3.1 1.8.7 2.2.6 2.6.5.4 0 1.2-.5 1.4-1s.2-.9.1-1c-.1-.1-.2-.2-.5-.3l-1.6-.8c-.2-.1-.4-.1-.5.1l-.6.8c-.1.1-.2.2-.4.1-.2-.1-.9-.3-1.7-1.1-.6-.6-1-1.3-1.2-1.5-.1-.2 0-.3.1-.4l.4-.5c.1-.1.1-.3.1-.4l-.7-1.7c-.1-.3-.3-.3-.5-.3z" />
  </svg>
);

const SpotifyGlyph = () => (
  <svg className="social-icon" width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm4.4 14.4c-.2.3-.5.4-.8.2-2.2-1.3-4.9-1.6-8.1-.9-.3.1-.6-.1-.7-.4-.1-.3.1-.6.4-.7 3.5-.8 6.5-.5 9 1 .3.1.4.5.2.8zm1.2-2.7c-.2.3-.6.5-.9.3-2.5-1.5-6.3-2-9.3-1.1-.4.1-.7-.1-.9-.5-.1-.4.1-.7.5-.9 3.4-1 7.6-.5 10.5 1.3.3.1.4.6.1.9zm.1-2.8C14.5 9.1 9.6 8.9 6.8 9.8c-.4.1-.9-.1-1-.5-.1-.4.1-.9.5-1 3.2-1 8.6-.8 12 1.2.4.2.5.7.3 1.1-.2.3-.7.4-1.1.2z" />
  </svg>
);

const ICONS = {
  instagram: InstagramOutlined,
  twitter: TwitterOutlined,
  youtube: YoutubeOutlined,
  email: MailOutlined,
  tiktok: TikTokGlyph,
  whatsapp: WhatsappGlyph,
  spotify: SpotifyGlyph
};

const SocialIcon = ({ type }) => {
  // `type` is user data: hasOwnProperty keeps 'constructor' from finding Object's
  const Icon = Object.prototype.hasOwnProperty.call(ICONS, type) ? ICONS[type] : LinkOutlined;
  return <Icon className="social-icon" />;
}

export default SocialIcon
